import url from "./baseUrl";
import { GET, POST, JSONP, Form, POSTBody, exportFile } from "./apiFn";
import { get } from "https";

export default {
  /**
 @method login
 @param {String,String} 参数名:{user,psw}
 @description 账号,密码
*/
  login: params => GET(url.login, params), // 企业登录

  /**
 @method getMap
 @param {String,String} 参数名:{user,psw}
 @description 账号,密码
*/
  getMap: params => GET(url.getMap, params), // 获取地图信息

  /**
 @method updatePwd
 @param {String,String,Number} 参数名:{newPwd,oldPwd，userId}
 @description 新密码,旧密码,userId
*/
  updatePwd: params => POST(url.updatePwd, params), // 修改密码

  /**
 @method loadGroupsData
 @param {} 参数名:{} 
 @description 
*/
  loadGroupsData: params => GET(url.loadGroupsData, params), // 加载车组或批次数据

  /**
 @method delGprsBagInfo
 @param {number} 参数名:{gprsId}
 @description 套餐ID
*/
  delGprsBagInfo: params => GET(url.delGprsBagInfo, params), // 删除套餐信息

  /**
 @method pushNumSegment
 @param {string,string,string,number,string} 参数名:{allDate,batch,endCard,pushType,startCard	}
 @description 批量入库卡号,入库批次,结束卡号,入库类型,起始卡号
*/
  pushNumSegment: params => GET(url.pushNumSegment, params), // 卡段入库OR批量入库

  /**
      @method addAndUpdateGprsBag
      @param {number,string,string,number} 参数名:{	gprsId,gprsType,remark,type}
      @description 套餐ID,套餐量,套餐说明,套餐单位
    */
  addAndUpdateGprsBag: params => GET(url.addAndUpdateGprsBag, params), // 新增修改套餐

  /**
      @method findByGprsBagList
      @param {} 参数名:{}
      @description 
    */
  findByGprsBagList: params => GET(url.findByGprsBagList, params), // 获取套餐信息列表

  /**
   @method delGprsBagInfo
   @param {number} 参数名:{gprsId}
   @description 套餐ID
    */
  delGprsBagInfo: params => GET(url.delGprsBagInfo, params), // 获取套餐信息详情

  /**
   @method getDestroyCardDetail
   @param {number,number,number} 参数名:{destroyId,pageNumber,pageSize	}
   @description ID,当前页,条数
    */
  getDestroyCardDetail: params => GET(url.getDestroyCardDetail, params), // 获取销卡详细信息

  /**
      @method orderCard
      @param {number,string,number,number,number,string,string} 参数名:{aUserId,orderId,outType,price,remark,startCard}
      @description 出库A级客户ID,结束卡号,订单ID,出库类型,出库单价,备注说明,开始卡号
    */
  orderCard: params => GET(url.orderCard, params), // 订单出库

  /**
   @method backCard
   @param {string} 参数名:{cardNo}
   @description 卡号
    */
  backCard: params => GET(url.backCard, params), // 退卡入库

  /**
   @method chargeOffCard
   @param {string,string} 参数名:{cardNo,remark}
   @description 卡号,销卡说明
    */
  chargeOffCard: params => GET(url.chargeOffCard, params), // 销卡

  /**
   @method getDestroyCardInfo
   @param {number,number} 参数名:{pageNumber,pageSize}
   @description 当前页,条数
    */
  getDestroyCardInfo: params => GET(url.getDestroyCardInfo, params), // 获取销卡详细信息

  /**
   @method loadSimListByGroups
   @param {string,string,number,string,number,number,string,number} 参数名:{endIccid,groups,searchType,simCard,simState,simType,startIccid,userId}
   @description 结束卡号,卡组批次,搜索类型,卡号,SIM卡状态,SIM卡类型,开始卡号,用户ID
    */
  loadSimListByGroups: params => GET(url.loadSimListByGroups, params), // 获得卡组或批次的SIM卡信息

  /**
   @method updateUser
   @param {number,string,string,string,string,string,number,string,string,string,number} 参数名:{accountType,address,corpName,customCode,idCard,name,parentId,password,phone,remark,userId}
   @description 账号类型,地址,公司名称,客户代码,身份证,姓名,上级用户ID,密码,电话,备注,用户ID
    */
  updateUser: params => POST(url.updateUser, params), // 修改客户

  /**
   @method addUser
   @param {number,string,string,string,string,string,number,string,string,string} 参数名:{accountType,address,corpName,customCode,idCard,name,parentId,password,phone,remark}
   @description 账号类型,地址,公司名称,客户代码,身份证,姓名,上级用户ID,密码,电话,备注
    */
  addUser: params => POST(url.addUser, params), // 添加用户

  /**
   @method getUserInfo
   @param {number} 参数名:{userId}
   @description 用户ID
    */
  getUserInfo: params => GET(url.getUserInfo, params), // 获取用户信息

  /**
   @method getManageUserInfo
   @param {number} 参数名:{userId}
   @description 用户ID
    */
  getManageUserInfo: params => GET(url.getManageUserInfo, params), // 获得用户列表

  /**
   @method getOrderList
   @param {string,number,number,number,string} 参数名:{findCode,orderStatus,pageNumber,pageSize,serMeal}
   @description 模糊搜索（客户代码/订单号,订单状态,当前页,条数,套餐类型
    */
  getOrderList: params => GET(url.getOrderList, params), // 获取订单列表

  /**
   @method getOrderDetail
   @param {number} 参数名:{orderId}
   @description 订单ID
    */
  getOrderDetail: params => GET(url.getOrderDetail, params), // 获取订单详情

  /**
   @method pushCustomerOrder
   @param {string,string,string,string,string} 参数名:{count,orderPrice,remark,type,userCode}
   @description 数量,单价,备注,套餐,客户代码
    */
  pushCustomerOrder: params => POST(url.pushCustomerOrder, params), // 订单提交

  /**
   @method runOrderInfo
   @param {string,number,string,string,string} 参数名:{counts,orderId,orderPrice,remark,serMeal}
   @description 购买数量,订单ID,购买单价,备注说明,套餐类型
    */
  runOrderInfo: params => GET(url.runOrderInfo, params), // 销售端设置购买单价

  /**
   @method setGlobalRisk
   @param {string,string,string,string,number,string} 参数名:{allIccid,exceedGprs,fixDate,overGprs,riskType,simType}
   @description 对选择卡进行设置,预超流量,	停卡时间,	剩余流量,风控类型1:全局 2:部分,套餐类型
    */
  setGlobalRisk: params => POST(url.setGlobalRisk, params), // 销售端设置购买单价

  /**
   @method getNextUserInfo
   @param {number} 参数名:{userId}
   @description 用户ID
    */
  getNextUserInfo: params => GET(url.getNextUserInfo, params), // 获得用户子集用户

  /**
   @method getIndexRunData
   @param {number} 参数名:{userId}
   @description 用户ID
    */
  getIndexRunData: params => GET(url.getIndexRunData, params), // 获得动态数据

  /**
   @method getClientIndexStopData
    */
  getClientIndexStopData: params => GET(url.getClientIndexStopData, params), // 获得静态数据

  /**
   @method loadInventoryData
    */
  loadInventoryData: params => GET(url.loadInventoryData, params), // 获得静态数据

  /**
 @method addSimGroup
  */
  addSimGroup: params => POSTBody(url.addSimGroup, params), // 新增卡组

  /**
  @method loadSimGroup
   */
  loadSimGroup: params => GET(url.loadSimGroup, params), // 新增卡组

  /**
 @method clientSearchSimListByInventory
  */
  clientSearchSimListByInventory: params => POST(url.clientSearchSimListByInventory, params), // 搜索库存下的sim卡新

  /**
 @method searchSimListByGroups
  */
  searchSimListByGroups: params => GET(url.searchSimListByGroups, params), // 搜索库存下的sim卡新

  /**
 @method transferGroupSim
 @param {String,Number} 参数名:{batch,groupId}
 @description 
  */
  transferGroupSim: params => POSTBody(url.transferGroupSim, params), // 搜索库存下的sim卡新

  /**
 @method transferUserSim
 @param {String,Number} 参数名:{batch,groupId}
 @description 
  */
  transferUserSim: params => POSTBody(url.transferUserSim, params), // 搜索库存下的sim卡新

  /**
 @method sellSimList
 @param {String,Number} 参数名:{batch,groupId}
 @description 
  */
  sellSimList: params => GET(url.sellSimList, params), // 搜索库存下的sim卡新

  /**
 @method sendBatchSms
 @param {string,string} 参数名:{content,iccids}
 @description 下发内容,iccid(批量短信下发用逗号隔开)
  */
  sendBatchSms: params => POST(url.sendBatchSms, params), // 批量短信下发

  /**
 @method getSendSmsStatus
 @param {string,string} 参数名:{contentId,iccids}
 @description 短信下发时返回的内容ID,iccid(批量短信下发用逗号隔开)
  */
  getSendSmsStatus: params => POST(url.getSendSmsStatus, params), // 获取批量短信下发的状态

  /**
 @method getDevReply
 @param {String} 参数名:{cardNo}
 @description 物联网卡号
  */
  getDevReply: params => POST(url.getDevReply, params), // 获取单卡的设备回复历史内容

  /**
  @method getIotLlcx
  @param {String} 参数名:{iccid}
  @description 	物联网卡ICCID
   */
  getIotLlcx: params => GET(url.getIotLlcx, params), // 更新单卡的套餐流量信息

  /**
  @method getSendMsg
  @param {String} 参数名:{simCard}
  @description 		物联网卡号
   */
  getSendMsg: params => GET(url.getSendMsg, params), // 获取短信下发记录

  /**
  @method getOrderHistory
  @description 		获取订单历史
   */
  getOrderHistory: params => GET(url.getOrderHistory, params), // 获取订单历史

  /**
  @method updateSimGroup
  @description 		修改卡组信息
   */
  updateSimGroup: params => POST(url.updateSimGroup, params), // 修改卡组信息

  /**
  @method getDevReplyNewOne
  @param {String} 参数名:{cardNo}
  @description 物联网卡号
   */
  getDevReplyNewOne: params => POST(url.getDevReplyNewOne, params), // 获取批量短信下发的状态

  /**
  @method restockUserSim
  @description 		获取订单历史
   */
  getRiskManage: params => GET(url.getRiskManage, params), // 获取预期/过期卡信息

  /**
   @method searchSimListByInventory
    */
  searchSimListByInventory: params => POST(url.searchSimListByInventory, params), // 搜索库存下的sim卡新

  getSimGprsCount: params => GET(url.getSimGprsCount, params), //获取预/已超流量的sim卡数量

  getSimCardsCount: params => GET(url.getSimCardsCount, params), //获取预/已过期的sim卡数量

  exportRiskSimCard: params => GET(url.exportRiskSimCard, params), //导出对应所有sim卡

  getCountOfStock: params => GET(url.getCountOfStock, params), //获取出入库数据

  restockUserSim: params => POST(url.restockUserSim, params), // 获取订单历史

  exportCustomerSim: params => GET(url.exportCustomerSim, params), // 导出

  getIotLlcxAll: params => GET(url.getIotLlcxAll, params), // 批量获取SIM卡信息

  uploadPayCode: params => Form(url.uploadPayCode, params), // 上传二维码

  getCustomPayCode: params => GET(url.getCustomPayCode, params), // 获取二维码

  addRemarkOfSim: params => GET(url.addRemarkOfSim, params), // 获取二维码

  searchAllSimListByInventory: params => GET(url.searchAllSimListByInventory, params), // 获取获取我的卡

  transferSimByCustom: params => POST(url.transferSimByCustom, params), // 划拨

  getRecordAll: params => GET(url.getRecordAll, params), // 

  getSendSmsStatusByContentId: params => GET(url.getSendSmsStatusByContentId, params), // 轮询批量短信状态 

  getUserCornInfo: params => POST(url.getUserCornInfo, params), // 获取用户信息和币数 

  getRechargeReport: params => POSTBody(url.getRechargeReport, params), // 报表查询(充值) 

  getTransferReport: params => POSTBody(url.getTransferReport, params), // 报表查询(划拨记录)

  transferCorn: params => POSTBody(url.transferCorn, params), // (充值、划拨记录)虚拟币划拨操作

  exportRechargeReport: params => exportFile(url.exportRechargeReport, params), //(充值记录)报表导出

  exportTransferReport: params => exportFile(url.exportTransferReport, params), //(划拨记录)报表导出

  exportConsumeReport: params => exportFile(url.exportConsumeReport, params), //(消费记录)报表导出

  getCornConsumeReport: params => POSTBody(url.getCornConsumeReport, params), // 查询消费记录

  renewCardByCorn: params => POSTBody(url.renewCardByCorn, params), // 计算续费

  exameCornRenew: params => POSTBody(url.exameCornRenew, params), // 续费操作(扣币后进行年限续费、添加记录)

  setSecondPassword: params => POSTBody(url.setSecondPassword, params), // 二级密码设置(客户端)

  getPackageKind: params => POSTBody(url.getPackageKind, params), // 获取所有叠加包套餐类型

  checkFlowPackage: params => POSTBody(url.checkFlowPackage, params), // 检测当前客户是否能够线上叠加包(流量池卡)【返回新旧卡区分】

  exameFlowPackage: params => POSTBody(url.exameFlowPackage, params), // 确认当前叠加包操作

  parserExcelToSegment: params => Form(url.parserExcelToSegment, params), // 解析报表数据生成卡段

  queryCustomTips: params => POSTBody(url.queryCustomTips, params), // 查询客户提示

  modifyCustomTips: params => POSTBody(url.modifyCustomTips, params), // 修改客户提示信息

  getIotLlcxList: params => POSTBody(url.getIotLlcxList, params), // 批量刷新卡的流量套餐信息

  getSimRenewPriceList: params => POSTBody(url.getSimRenewPriceList, params), // 续费单价管理

  updateRenewalManagement: params => POST(url.updateRenewalManagement, params), // 修改续费信息

  getUserRenewalRecordBySim: params => POSTBody(url.getUserRenewalRecordBySim, params), // 用户续费记录查询

  gprsHistory: params => GET(url.gprsHistory, params), // 用户续费记录查询

  countFlowConsumeRank: params => GET(url.countFlowConsumeRank, params), //新首页，流量消耗排行

  countCorn: params => GET(url.countCorn, params), //虚拟币统计

  simCardStocks: params => GET(url.simCardStocks, params), //卡库存

  CornConsumeCondition: params => GET(url.CornConsumeCondition, params), //虚拟币消耗情况

  downloadTemplate: params => POST(url.downloadTemplate, params), //模板下载

  getSimBySpecifiedField: params => GET(url.getSimBySpecifiedField, params), //sn卡关联搜索

  gerSnRelationAllInfo: params => GET(url.gerSnRelationAllInfo, params), //获取当前用户下所有sn关联信息

  getSnRelationImportTemp: params => GET(url.getSnRelationImportTemp, params), //查询校验的结果（上传设备文件之后调用）

  updateErrorInfo: params => POSTBody(url.updateErrorInfo, params), //修改并校验错误结果(返回修改信息)

  batchAddSnRelation: params => POST(url.batchAddSnRelation, params), //提交录入卡资料（批量添加）

  clearImportTemp: params => POSTBody(url.clearImportTemp, params), //清除数据库缓存信息

  readHistoryGprsFlow: params => GET(url.readHistoryGprsFlow, params), //清除数据库缓存信息

  getVariousSimCount: params => GET(url.getVariousSimCount, params), //获取各种卡数量

  uploadSN: params => Form(url.uploadSN, params), //获取各种卡数量

  deleteSubAccount: params => GET(url.deleteSubAccount, params), //删除当前用户下的子用户

  transferSimCard: params => POSTBody(url.transferSimCard, params), //子用户的卡划拨至其他用户(用于处理删除子用户时，子用户还遗留的卡)

  confirmGuaranteeInfo: params => POSTBody(url.confirmGuaranteeInfo, params), //确认停机保号费信息

  operationGuaranteeInfo: params => POSTBody(url.operationGuaranteeInfo, params), //审核停机保号费

  updateUserEmail: params => POSTBody(url.updateUserEmail, params), //添加、修改邮箱

  deleteUserEmail: params => POST(url.deleteUserEmail, params), //删除邮箱


  deleteSnInfo: params => POST(url.deleteSnInfo, params), //删除邮箱
  batchDeleteSnInfo: params => POST(url.batchDeleteSnInfo, params), //根据sn号批量删除设备信息
  batchAddRemarkOfSim: params => GET(url.batchAddRemarkOfSim, params), //批量添加备注
  updateSnInfo: params => POSTBody(url.updateSnInfo, params), //修改设备信息
  getTrafficInfo: params => GET(url.getTrafficInfo, params), //获取fc68的流量池信息
  getSpecialCustomOverPrice: params => POSTBody(url.getSpecialCustomOverPrice, params), //获取特殊客户叠加包价格
  queryCardBindStatus: params => GET(url.queryCardBindStatus, params), //查询最新物联卡机卡分离状态
  getCardBindStatusRecord: params => GET(url.getCardBindStatusRecord, params), //获取SIM卡最近机卡分离记录
  exportSimBySpecifiedField: params => exportFile(url.exportSimBySpecifiedField, params), //导出sn相关信息
  pageOrderInfo: params => GET(url.pageOrderInfo, params), //获取PC端续费报表
  pageSnRelationLog: params => GET(url.pageSnRelationLog, params), //分页sn关联修改日志
  updateOrderInfo: params => POSTBody(url.updateOrderInfo, params), //修改订单处理状态
  wechatOrder: params => exportFile(url.wechatOrder, params), //导出续费报表

  pageExternalSimRenewPrice: params => GET(url.pageExternalSimRenewPrice, params), //分页获取续费价格
  addExternalSimRenewPrice: params => POSTBody(url.addExternalSimRenewPrice, params), //新增续费价格
  updateExternalSimRenewPrice: params => POSTBody(url.updateExternalSimRenewPrice, params), //修改续费价格
  deleteExternalSimRenewPrice: params => POSTBody(url.deleteExternalSimRenewPrice, params), //修改续费价格
  updateExternalSimRenewPriceByDeviceType: params => POSTBody(url.updateExternalSimRenewPriceByDeviceType, params), //根据设备类型修改续费价格
  exportExternalSimRenewPrice: params => exportFile(url.exportExternalSimRenewPrice, params), //导出续费信息
  getExternalSimRenewPrice: params => GET(url.getExternalSimRenewPrice, params), //根据id获取续费信息
  importExternalSimRenewPrice: params => Form(url.importExternalSimRenewPrice, params), //导入续费资料
  batchUpdateExternalSimRenewPrice: params => Form(url.batchUpdateExternalSimRenewPrice, params), //导入续费资料
  exportNotExternalSimRenewPrice: params => exportFile(url.exportNotExternalSimRenewPrice, params), //导出账号下未设值续费价格的卡信息
  readHistoryGprsFlow: params => GET(url.readHistoryGprsFlow, params), //
  monthlyStatisticsOldHistoryGprsFlow: params => GET(url.monthlyStatisticsOldHistoryGprsFlow, params), //
  historyReadHistoryGprsFlow: params => GET(url.historyReadHistoryGprsFlow, params), //

  downloadSmsSendTemplate: params => exportFile(url.downloadSmsSendTemplate, params), //短信发送模板下载
  importSmsSendInfo: params => Form(url.importSmsSendInfo, params), //批量导入短信信息
};
